import React from "react";
import { useNoAuth } from "@redwoodjs/auth";
const getApiGraphQLUrl = () => {
  return globalThis.RWJS_API_GRAPHQL_URL;
};
const FetchConfigContext = React.createContext({
  uri: getApiGraphQLUrl()
});
const FetchConfigProvider = ({
  useAuth = useNoAuth,
  ...rest
}) => {
  const { isAuthenticated, type } = useAuth();
  if (!isAuthenticated) {
    return /* @__PURE__ */ React.createElement(
      FetchConfigContext.Provider,
      {
        value: { uri: getApiGraphQLUrl() },
        ...rest
      }
    );
  }
  const headers = {
    "auth-provider": type
  };
  return /* @__PURE__ */ React.createElement(
    FetchConfigContext.Provider,
    {
      value: {
        uri: getApiGraphQLUrl(),
        headers
      },
      ...rest
    }
  );
};
const useFetchConfig = () => React.useContext(FetchConfigContext);
export {
  FetchConfigContext,
  FetchConfigProvider,
  getApiGraphQLUrl,
  useFetchConfig
};
